import { type Consumer, createConsumer } from '@rails/actioncable';
import { createContext, useContext, type PropsWithChildren } from 'react';

const ActionCableContext = createContext<Consumer | null>(null);

export const ActionCableProvider = ({
  children,
  url,
}: PropsWithChildren<{ url: string }>) => {
  const cable = createConsumer(url);

  return (
    <ActionCableContext.Provider value={cable}>
      {children}
    </ActionCableContext.Provider>
  );
};

export const useActionCable = (): Consumer => {
  const context = useContext(ActionCableContext);

  if (!context) {
    throw new Error(
      'useActionCable must be used within the ActionCable provider',
    );
  }

  return context;
};
